import { FC, SVGProps } from "react";

const DsquaresLogoMark: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width={500} height={530} viewBox="0 0 500 530" fill="none" {...props}>
      <path
        d="M295.726 278.163V164.568H91V482.889H409.321V278.163H295.726ZM295.676 373.712H200.177V278.213H295.676V373.712Z"
        fill="#0071CE"
      />
      <path d="M407.509 47H295.725V158.784H407.509V47Z" fill="#0071CE" />
    </svg>
  );
};

export default DsquaresLogoMark;
